import { createContext } from 'react'
import { AnalyticsClient } from '../types'

export const AnalyticsContext = createContext<AnalyticsClient>(null)
